import { DataViewHeader, FlexSpacer } from '@vtex/admin-ui';
import { SearchBar, TitlesGroup } from 'lib/components/molecules';

import { useTranslation } from 'react-i18next';

type Props = {
  collectionId: string;
  collectionName: string;
  onSearch: (debouncedValue: string) => void;
};

export const Header = ({ collectionId, collectionName, onSearch }: Props) => {
  const { t } = useTranslation();

  return (
    <DataViewHeader>
      <TitlesGroup
        title={t('adminHighlightProduct.title')}
        subTitle={t('adminHighlightProduct.subTitle')}
        subTitle2={t('adminHighlightProduct.collection', {
          name: collectionName,
          id: collectionId,
        })}
      />
      <FlexSpacer />
      <SearchBar onSearch={onSearch} />
      <FlexSpacer />
    </DataViewHeader>
  );
};
